import React, { useState, useEffect } from "react";
import "./AdminMediaGallery.css";

const API_BASE = "https://rbuymart.rbhardwaj.com/server/api/admin/media_gallery.php";

const foldersList = ["products", "blogimg", "Category", "landing", "review"];

const AdminMediaGallery = () => {
  const [selectedFolder, setSelectedFolder] = useState("products");
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  // 🟢 Progress Bar State (0 to 100)
  const [uploadProgress, setUploadProgress] = useState(0);

  // Replace/Update State
  const [replacingImage, setReplacingImage] = useState(null);

  useEffect(() => {
    fetchGalleryImages(selectedFolder);
  }, [selectedFolder]);

  const fetchGalleryImages = async (folder) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}?folder=${folder}`);
      const result = await res.json();
      if (result.status === "success") {
        setImages(result.data || []);
      }
    } catch (err) {
      alert("Error loading gallery: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // 🟢 XMLHttpRequest ka use karke Real-time Progress Track karne wala Upload Function
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);
    formData.append("folder", selectedFolder);
    formData.append("action", replacingImage ? "replace" : "upload");

    if (replacingImage) {
      formData.append("old_filename", replacingImage);
    }

    setUploading(true);
    setUploadProgress(0);

    const xhr = new XMLHttpRequest();

    // 📊 Track Upload Progress Percentage
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);
        setUploadProgress(percentComplete);
      }
    };

    // 🟢 Handle Success / Response
    xhr.onload = () => {
      setUploading(false);
      setUploadProgress(0);
      e.target.value = null; // Reset input field

      try {
        const result = JSON.parse(xhr.responseText);
        if (xhr.status === 200 && result.status === "success") {
          alert(result.message);
          setReplacingImage(null);
          fetchGalleryImages(selectedFolder);
        } else {
          alert("Upload Failed: " + (result.message || "Unknown Error"));
        }
      } catch (err) {
        alert("Server Response Error: " + xhr.responseText);
      }
    };

    // 🔴 Handle Upload Error
    xhr.onerror = () => {
      setUploading(false);
      setUploadProgress(0);
      e.target.value = null;
      alert("Network Error occurred during upload.");
    };

    xhr.open("POST", API_BASE, true);
    xhr.send(formData);
  };

  // 🔴 Handle Delete Image
  const handleDeleteImage = async (img) => {
    // Alert user if image is currently linked in DB
    const confirmMessage = img.is_used
      ? `⚠️ WARNING: "${img.name}" is currently IN USE in your database!\nAre you sure you still want to delete it?`
      : `Are you sure you want to delete "${img.name}"?`;

    if (!window.confirm(confirmMessage)) return;

    const formData = new FormData();
    formData.append("action", "delete");
    formData.append("folder", selectedFolder);
    formData.append("filename", img.name);

    try {
      const res = await fetch(API_BASE, {
        method: "POST",
        body: formData,
      });
      const result = await res.json();

      if (result.status === "success") {
        fetchGalleryImages(selectedFolder);
      } else {
        alert("Delete Failed: " + result.message);
      }
    } catch (err) {
      alert("Delete Error: " + err.message);
    }
  };

  // Copy Image Link to Clipboard
  const copyToClipboard = (url) => {
    navigator.clipboard.writeText(url);
    alert("Image URL copied to clipboard!");
  };

  return (
    <div className="media-gallery-container">
   
 <div class="admin-header-tap">
     
          <h3>Media Gallery</h3>
        <div className="flex-div">
      <div className="upload-box">
          <label htmlFor="gallery-file-input" className="btn-upload">
            {uploading
              ? `Uploading...`
              : replacingImage
              ? `Replace "${replacingImage}"`
              : `Upload Image`}
          </label>
          <input
            id="gallery-file-input"
            type="file"
            accept="image/*"
            onChange={handleFileUpload}
            disabled={uploading}
          />
          {replacingImage && !uploading && (
            <button
              className="btn-cancel-replace"
              onClick={() => setReplacingImage(null)}
            >
              Cancel Replace
            </button>
          )}
        </div>
  
        </div>
        </div>


   



    
      <div className="folder-tabs">
        {foldersList.map((folder) => (
          <button
            key={folder}
            className={`folder-tab-btn ${selectedFolder === folder ? "active" : ""}`}
            onClick={() => {
              setSelectedFolder(folder);
              setReplacingImage(null);
            }}
          >
            📁 {folder}
          </button>
        ))}
      </div>

             {uploading && (
          <div className="progress-bar-container">
            <div className="progress-bar-track">
              <div
                className="progress-bar-fill"
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
            <span className="progress-percentage-text">{uploadProgress}%</span>
          </div>
        )}

      {/* Gallery Grid */}
      {loading ? (
        <div className="gallery-loader">Loading images...</div>
      ) : images.length === 0 ? (
        <div className="empty-gallery">No images found in "{selectedFolder}" folder.</div>
      ) : (
        <div className="media-grid section-div">
          {images.map((img) => (
            <div className="media-card" key={img.name}>
              <div className="image-preview">
                <img src={img.url} alt={img.name} loading="lazy" />

                {/* 🟢 DB Usage Status Badge */}
                <span className={`usage-badge ${img.is_used ? "used" : "unused"}`}>
                  {img.is_used ? "● In Use" : "○ Unused"}
                </span>
              </div>

              <div className="media-info">
                <p className="file-name" title={img.name}>{img.name}</p>
                <p className="file-meta">{img.size} | {img.modified}</p>
              </div>

              <div className="card-actions">
                <button
                  className="btn-action copy"
                  onClick={() => copyToClipboard(img.url)}
                  title="Copy URL"
                >
                  🔗 Link
                </button>
                <label
                  htmlFor="gallery-file-input"
                  className="btn-action edit"
                  onClick={() => setReplacingImage(img.name)}
                  title="Replace with new image"
                >
                  ✏️ Replace
                </label>
                <button
                  className="btn-action delete"
                  onClick={() => handleDeleteImage(img)}
                  title="Delete image"
                >
                  🗑️ Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminMediaGallery;